import React from 'react'
import { Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import LatestPayslip from './pages/latest_payslip'
import AllPayslips from './pages/all_payslips'
import ViewPayslip from './pages/view_payslip'
import NotAuthorisedPage from './pages/login_not_authorised'
import AccountErrorPage from './pages/account_error'
import ErrorPage from './pages/error'
import PrintView from './pages/print_view'
import ResetPin from './pages/reset_pin'
import {connect} from 'react-redux'
import store from './store'
import EnterYourPin from './pages/enter_your_pin'
import EnterYourNino from './pages/enter_your_nino'
import Register from './pages/register'
import Spinner from './components/spinner'
import TimedOut from './pages/timed_out'
import Admin from './pages/admin'
import PinLockout from './pages/pin_lockout'
import NotAuthorised from './pages/not_authorised'
import Login from './pages/login'
import {refreshActivityTimer} from './components/timeout'


function authy(comp, bypass_pin_entry, admin_only ) {
    const Authy = function(props) {

//!props.store.oauth_token

        if( !props.store.oauth_token && props.store.current_user.verified == null && props.store.current_user.locked_out == null) {
            return <Login/>
        }

        if( !props.store.current_user.verified ){
            return <EnterYourNino/>
        }

        const errorMessage = props.store.current_user.treat_as_error ? "Error retrieving your details" : null
        if( props.store.current_user.show_spinner || props.store.current_user.treat_as_error  ) return <Spinner {...props} errorMessage={errorMessage}/>
        if( !props.store.token && ! props.store.current_user.is_pin_setup ) return <Register {...props}/>

        if( admin_only && !props.store.current_user.is_admin ) {
            return <NotAuthorised {...props}/>
        }

        if(bypass_pin_entry)
            return React.createFactory(comp)({...props})
        else
            return props.store.token ?
                React.createFactory(comp)({...props})
                    :
                <EnterYourPin {...props}/>
    }

    return connect((store) => store )(Authy)
}

const history = syncHistoryWithStore(browserHistory, store)

export function resetViewportZoom(){
    var viewportmeta = document.querySelector('meta[name="viewport"]');
    if (viewportmeta) {
        viewportmeta.setAttribute('content', 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0');
        viewportmeta.setAttribute('content', 'width=device-width, initial-scale=1.0');
    }
}

function onUpdate(){
    if( store.getState().store.oauth_token ) {
        resetViewportZoom()
        refreshActivityTimer()
    }
}

export default function(props) {

    return (
        <Router history={history} onUpdate={() => onUpdate()}>
            <Route path="/" component={authy(LatestPayslip, false)}/>
            <Route path="/latest-payslip" component={authy(LatestPayslip, false)}/>
            <Route path="/payslips" component={authy(AllPayslips, false)}/>
            <Route path="/payslip/:payslip_id" component={authy(ViewPayslip, false)}/>
            <Route path="/print-payslip" component={authy(PrintView, false)}/>
            <Route path="/manage-users" component={authy(Admin, false, true)}/>
            <Route path="/reset-pin" component={authy(ResetPin, true)}/>
            <Route path="/timeout" component={connect((store) => store )(TimedOut)}/>
            <Route path="/account-locked" component={connect((store) => store )(PinLockout, true)}/>
            <Route path="/not-authorised" component={NotAuthorisedPage}/>
            <Route path="/account-error" component={AccountErrorPage}/>
            <Route path="/error" component={ErrorPage}/>
        </Router>
    )
}


// WEBPACK FOOTER //
// ./src/routes.js